import urlApiV2 from '@/router/urlApiV2'
import Vue from 'vue'
import Toast from 'vue-toasted'

Vue.use(Toast)
export default {
	// ALERT TOAST
	launchToast(icon, msg) {
		Vue.toasted.show(msg, {
			icon: icon,
			position: 'top-right',
			duration: 5000,
			fullWidth: false
		})
	},
	// CARREGAR AUTO ESCOLAS
	async loadCfc () {
		let selectCFC = [
			{ value: '', text: 'SELECIONE UMA AUTO ESCOLA' },
		]

		Vue.http.get(urlApiV2 + '/autoescola').then(response => {
			response.data.dados.map(autoescolas => {
				if (autoescolas.nome_fantasia !== 'TESTE') {
					selectCFC.push({
						value: autoescolas.tenant_schema,
						text: autoescolas.nome_fantasia,
					})
				}
			})
		})

		return selectCFC
	},
	async queryResult(data, callback) {
		const query = `${urlApiV2}/aulas/teoricas/monitoramento/fotos/consultar/filtros?agrupamento=${data.agrupamento}&cfc=${data.cfc}&nome=${data.nome}&dispositivo=${data.dispositivo}&periodo[]=${data.dataInicio}&periodo[]=${data.dataFim}`;
		
		Vue.http.get(query).then(response => {
				callback(response.data.dados)
		}).catch(error => {
			if (error.status === 400) {
				if (error.data.mensagem === 'Undefined offset: 0') {
					this.launchToast('fa-warning', 'Nenhum registro encontrado!')
				} else {
					this.launchToast('fa-warning', error.data.mensagem)
				}
			}

			callback(error.data)
		})
	},

	async getAlunosMonitorados (data, callback) {
        const query = `${urlApiV2}/export/planilha/turmas-teoricas/fotos-monitoradas?periodo%5B%5D=${data.dataInicio}&periodo%5B%5D=${data.dataFim}`;

        Vue.http.get(query)
        .then(response => {
            callback(response.data)
        })
        .catch(error => {
            this.launchToast('fa-warning', error.data.mensagem)
            callback(error.data)
        })
    },
}